<avn-data-table [columns]="columns" [dataSource]="dataSource$ | async" [rowHeight]="50" [keyboardNavigationEnabled]="true" [headerTooltipsEnabled]="true" [infiniteScrollEnabled]="false">
  <avn-empty-data-message
    [icon]="'action:supervisor_account'"
    [text]="'siteManagementScope.SITE_MANAGEMENT.SITE_DETAIL.SITE_PROPERTIES_EDITOR.MANAGERS.NO_MANAGER_FOUND.TEXT_50' | transloco"
    [subText]="'siteManagementScope.SITE_MANAGEMENT.SITE_DETAIL.SITE_PROPERTIES_EDITOR.MANAGERS.NO_MANAGER_FOUND.SUBTEXT_100' | transloco"
  >
  </avn-empty-data-message>
</avn-data-table>
